let clientInstance;
let serverInstance;

const getRavenInstance = (key, config) => {
  const clientSide = typeof window !== 'undefined';

  if (clientSide) {
    if (!clientInstance) {
      const Raven = require('raven-js'); // eslint-disable-line global-require
      Raven.config(key, config).install();
      clientInstance = Raven;
    }

    return clientInstance;
  }

  if (!serverInstance) {
    // NOTE: raven (for node) is not bundled by webpack (see rules in next.config.js).
    const RavenNode = require('raven-js'); // eslint-disable-line global-require
    RavenNode.config(key, config).install();
    serverInstance = RavenNode;
  }
  return serverInstance;
};

const createConfigFrom = ({ version, environment, appEnvironment, hostname, domain }) => {
  const domainRegex = new RegExp(domain);
  const config = {
    release: version,
    environment,
    tags: {
      appEnvironment,
    },
    serverName: hostname,
    whitelistUrls: [domainRegex],
    ignoreErrors: [/SecurityError: Blocked a frame with origin.*/, 'QuotaExceededError'],
    captureUnhandledRejections: false,
    maxUrlLength: 1000, // avoid URL in sentry breadcrumb to be truncated at 250 chars
  };

  if (appEnvironment === 'development') {
    config.sampleRate = 0.0;
  }

  return config;
};

const reportError = (err, key, config, options = {}) => {
  const sentryConfig = createConfigFrom(config);
  const Raven = getRavenInstance(key, sentryConfig);

  // Avoid "undefined" error reports in Sentry
  if (err === undefined) {
    return;
  }

  if (!(err instanceof Error)) {
    err = new Error(`reportError -> err: ${JSON.stringify(err)}`); // eslint-disable-line no-param-reassign
  }

  Raven.captureException(err, options);
};

module.exports = {
  getRavenInstance,
  createConfigFrom,
  reportError,
};



// WEBPACK FOOTER //
// ./app/utils/raven.js